import { ComponentRef, Directive, EventEmitter, Input, OnDestroy, OnInit, Output, ViewContainerRef } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CustomViewConfig, ICustomViewComponent } from "./interfaces";

@Directive({
    selector: "[customViewHost]",
    standalone: false
})
export class CustomViewDirective<TConfig> implements OnDestroy, OnInit
{
    private readonly destructor$ = new Subject<void>();

    @Input() private readonly customViewHost: Observable<CustomViewConfig<TConfig>>;

    @Output() private readonly customComponent = new EventEmitter<ComponentRef<ICustomViewComponent<TConfig>>>();

    constructor(
        private viewContainerRef: ViewContainerRef
    ) { }

    ngOnDestroy(): void
    {
        this.destructor$.next();
        this.destructor$.complete();
    }

    ngOnInit(): void
    {
        this.customViewHost.pipe(takeUntil(this.destructor$))
            .subscribe(config =>
            {
                if (this.viewContainerRef.length > 1)
                {
                    // eslint-disable-next-line no-debugger
                    debugger;
                }

                this.viewContainerRef.clear();

                if (config.data)
                {
                    const componentRef = this.viewContainerRef.createComponent<ICustomViewComponent<TConfig>>(config.customView.component);
                    componentRef.instance.customDataBinding = config.data;
                    this.customComponent.emit(componentRef);
                }
            });
    }
}
